import { SvgIcon, SvgIconProps } from '@mui/material'

const ContactIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M19.5 19H5.5V5H19.5M19.5 3H5.5C4.96957 3 4.46086 3.21071 4.08579 3.58579C3.71071 3.96086 3.5 4.46957 3.5 5V19C3.5 19.5304 3.71071 20.0391 4.08579 20.4142C4.46086 20.7893 4.96957 21 5.5 21H19.5C20.0304 21 20.5391 20.7893 20.9142 20.4142C21.2893 20.0391 21.5 19.5304 21.5 19V5C21.5 3.89 20.6 3 19.5 3ZM17 16.25C17 14.75 14 14 12.5 14C11 14 8 14.75 8 16.25V17H17M12.5 12.25C13.0967 12.25 13.669 12.0129 14.091 11.591C14.5129 11.169 14.75 10.5967 14.75 10C14.75 9.40326 14.5129 8.83097 14.091 8.40901C13.669 7.98705 13.0967 7.75 12.5 7.75C11.9033 7.75 11.331 7.98705 10.909 8.40901C10.4871 8.83097 10.25 9.40326 10.25 10C10.25 10.5967 10.4871 11.169 10.909 11.591C11.331 12.0129 11.9033 12.25 12.5 12.25Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default ContactIcon
